import React, { useEffect } from 'react';
import Bussnies from '../components/Bussnies';
import SecondPageLayout from '../components/Layout/SecondPageLayout';
import { Box, Typography } from '@mui/material';
import introJs from 'intro.js';
import { BussniseTour as Tour } from '../enums/tourEnums';
import { useTour } from '../provider/TourGuide';
import { useAuth } from '../store/auth.store';

const BussniesPage = () => {
    const {onExitBussnies, setEnabledBussnies,bussniesNumber,setBussniesNumber, setOpenCreateUserModal} = useTour()
    const {user} = useAuth()
    useEffect(() => {
        if (!localStorage.getItem("bussnies") && user?.permission?.permissionDetaileds?.[0]?.isArchitecture) {
          if(bussniesNumber !== 4) {
            setBussniesNumber(1);
            setTimeout(() => {
              let didComplete = false;
              const intro = introJs()
              .onstart(() => {
                setEnabledBussnies(true);
              })
         
              .onskip(() => {
                didComplete = true;
                onExitBussnies()
                setBussniesNumber(0);
              })
              .onexit(() => {
                if (didComplete) {
                  return;
                }
                setOpenCreateUserModal(true)
                setTimeout(() => {
                  setBussniesNumber(2);
                },500)
              })

        
            intro.setOptions({
              ...Tour,
              scrollToElement: false,
              disableInteraction: true,
              showBullets: false,
            });
        
            intro.start();
            },500)
          }
        }
      }, 
    []);

    return (
        <SecondPageLayout withFooter={true}>
            <Box sx={{display:'flex', gap:'5px'}}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Component 2">
                    <path
                        id="Icon"
                        d="M17.9998 15.8369C19.4557 16.5683 20.704 17.742 21.6151 19.2096C21.7955 19.5003 21.8857 19.6456 21.9169 19.8468C21.9803 20.2558 21.7006 20.7585 21.3198 20.9204C21.1323 21 20.9215 21 20.4998 21M15.9998 11.5322C17.4816 10.7959 18.4998 9.26686 18.4998 7.5C18.4998 5.73314 17.4816 4.20411 15.9998 3.46776M13.9998 7.5C13.9998 9.98528 11.9851 12 9.49984 12C7.01455 12 4.99984 9.98528 4.99984 7.5C4.99984 5.01472 7.01455 3 9.49984 3C11.9851 3 13.9998 5.01472 13.9998 7.5ZM2.55907 18.9383C4.15337 16.5446 6.66921 15 9.49984 15C12.3305 15 14.8463 16.5446 16.4406 18.9383C16.7899 19.4628 16.9645 19.725 16.9444 20.0599C16.9287 20.3207 16.7578 20.64 16.5494 20.7976C16.2818 21 15.9137 21 15.1775 21H3.82219C3.08601 21 2.71791 21 2.45028 20.7976C2.24189 20.64 2.07092 20.3207 2.05527 20.0599C2.03517 19.725 2.2098 19.4628 2.55907 18.9383Z"
                        stroke="#2F4B6C"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    </g>
                </svg>
                <Typography color='#154D72' fontSize={'20px'} fontWeight={700} lineHeight={'28px'}>
                הרשאות, עובדים וסניפים
                </Typography>
            </Box>
            <Box sx={{mt:'20px'}}>
                {(bussniesNumber !== 4 && bussniesNumber !== 1) &&
                  <Bussnies.AreaList/>
                }
                <Bussnies.CompanyUsersList/>
            </Box>
        </SecondPageLayout>
    );
};

export default BussniesPage;